/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Request_SentInputs */

const en_document_request_sent = /** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access request sent to seller`)
};

const id_document_request_sent = /** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan akses terkirim ke penjual`)
};

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const es_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const fr_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const de_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const ja_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const zh_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const ar_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const it_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const ru_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const pt_document_request_sent = en_document_request_sent;

/** @type {(inputs: Document_Request_SentInputs) => LocalizedString} */
const ko_document_request_sent = en_document_request_sent;

/**
* | output |
* | --- |
* | "Access request sent to seller" |
*
* @param {Document_Request_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_request_sent = /** @type {((inputs?: Document_Request_SentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Request_SentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_request_sent(inputs)
	if (locale === "es") return es_document_request_sent(inputs)
	if (locale === "fr") return fr_document_request_sent(inputs)
	if (locale === "de") return de_document_request_sent(inputs)
	if (locale === "ja") return ja_document_request_sent(inputs)
	if (locale === "zh") return zh_document_request_sent(inputs)
	if (locale === "ar") return ar_document_request_sent(inputs)
	if (locale === "id") return id_document_request_sent(inputs)
	if (locale === "it") return it_document_request_sent(inputs)
	if (locale === "ru") return ru_document_request_sent(inputs)
	if (locale === "pt") return pt_document_request_sent(inputs)
	return ko_document_request_sent(inputs)
});